// extracted by mini-css-extract-plugin
export default {"LanguageSwitcher":"LanguageSwitcher_LanguageSwitcher__hWOl-"};